import Vue from 'vue'
import App from './App.vue'
import VuePageTransition from 'vue-page-transition'
import router from './router'
import store from './store'
import axios from 'axios'
import 'bootstrap'
import './sass/app.scss'

Vue.use(VuePageTransition)
Vue.config.productionTip = false

axios.defaults.withCredentials = true;
axios.defaults.baseURL = "https://api.tocinn.com"
axios.defaults.headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Authorization': 'Bearer 2|Z0qrLsvFOlK01A2LPMqVg9rI4uGfHjzZ7qRnuS3j'
};
// axios.defaults.baseURL = "http://localhost"
// axios.defaults.headers = {
//     'Content-Type': 'application/json',
//     'Accept': 'application/json',
//     'Access-Control-Allow-Origin': '*',
//     'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjY5OTUyMmNhZDk4ZmNjOWRkOTMwMzUyNGNlNTBjNWQ5N2I0MDgxODc3OWUwYzNlY2UwMzRiYjQ4YTY4NTkyODM5ZjEzYWRjZDUxNzFhNTc3In0.eyJhdWQiOiI0IiwianRpIjoiNjk5NTIyY2FkOThmY2M5ZGQ5MzAzNTI0Y2U1MGM1ZDk3YjQwODE4Nzc5ZTBjM2VjZTAzNGJiNDhhNjg1OTI4MzlmMTNhZGNkNTE3MWE1NzciLCJpYXQiOjE2MTY2MzQxNjksIm5iZiI6MTYxNjYzNDE2OSwiZXhwIjoxNjQ4MTcwMTY5LCJzdWIiOiIiLCJzY29wZXMiOltdfQ.hzcAfJi_fwvn_uE_k_TvOxDQ_8cIu6Wedjbe0i3c0UoIofzeqcdegmsybcDXWwh5ftubFg47EVtmCIlpR2r7O9GdqFO5hc9ZWMLta11WxcbH4glL5Aw4zdlb2DKW0s1V5Q--k2FUPY8Dyl5KNEPvArleFIDA-Hv-TbvnHsiDlP8zRe00CoJcPDD0pwh2hGrcletxPiuXZz8o_FjNxRKm-dFre4z1CckpGxucKjOU3Mq0NKpTqITNTSwkbML3bhqenIEIy261P2IOTXbyMcPZgzhm4FjG2jKOwBsmAKkbTkgWMKK_xPVhKOehFU0bI_Yn8NuZaxzRsdab8BIK0gi158En3nfbOoaEXOdzMrudLJGi5Jod87on-qAY-cF9e3nnK4QdNbKy0_6NzxhlplH1Y6nSqItxCrTLQzTb4xXs0meM7mJ1-kvSpO8fahOoP1Xw1cm5qxfY2hpsX5-k3EbcavW9NARk_9-inFuCMO3pU1ICLU3qiByc0jAG-oUDvS42w_uVNTc3ezP5ja7_5LrxQKDQCe7M7bwPEF3t0NBdMd_mSJipCEChpJVbngrtOYBXsDLkUYL2V7IvUKT5TiworNH6Nf08LuOPFz5Qyl5U26Qv2HHgCJIFiI5mUL7oDBX96XY1HioMd3f956_EDSJlNWAyPhivDrr5ruG3GbMcUnM'
// };

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
